import { env } from '@/config/env';

import { Worksheet } from './types';

export const getWorksheetScore = (worksheet?: Worksheet): number => {
  if (!worksheet) {
    return 0;
  }
  if (worksheet.total_marks && worksheet.aggregated_score) {
    const totalMarks = Number(worksheet.total_marks);
    const percentage = (worksheet.aggregated_score / totalMarks) * 100;
    return Math.round(percentage);
  }
  return Math.round(worksheet.aggregated_score ?? 0);
};

export const openLiveSessionInOldApp = (variantId: string) => {
  const url = `${env.OLD_APP_URL}/live-session?variant_id=${variantId}`;
  window.open(url, '_blank');
};
